import { render, staticRenderFns } from "./CreateDiscount.vue?vue&type=template&id=a952bf8a"
import script from "./CreateDiscount.vue?vue&type=script&lang=js"
export * from "./CreateDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports